import React from "react";
import BasePopup from "../Popup";
import bgCongPiece from "../../../../../assets/images/Mini-Game/bg-cong-piece.png";
import bgCongPieceSuper from "../../../../../assets/images/Mini-Game/bg-cong-piece-super.png";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import styled from "styled-components";
import iconPiece from "../../../../../assets/images/Mini-Game/piece-a.png";
import iconPieceB from "../../../../../assets/images/Mini-Game/delete-define-piece.png";
import bgBtn from "../../../../../assets/images/Mini-Game/bg-btn-give-piece-cong.png";
import bgBtnSuper from "../../../../../assets/images/Mini-Game/bg-btn-piece-popup-super.png";
import ButtonAction from "./components/ButtonAction";
import { useDispatch, useSelector } from "react-redux";
import {
  setOpenPopupChangeCoinsSuccess,
  setOpenPopupPiece,
  setOpenPopupGivePieceSuccess,
  getDataSpinUserMiniGame,
} from "../../../../../Redux/futures/mini-game/action";
import {
  ID_GIFT_PLAY_LOTO_MINIGAME,
  ID_TAB_MINI_GAME,
  TYPE_GIVE_PIECE_SUCCESS,
} from "../../../../../helper/const";
import iconBidFree from "../../../../../assets/images/Mini-Game/icon-bid-free.png";
import bgCoin from "../../../../../assets/images/Mini-Game/bg-coin-popup-cong.png";
import bgGoodluck from "../../../../../assets/images/Mini-Game/popup-good-luck-bg.png";
import bgCongReceive from "../../../../../assets/images/Mini-Game/bg-receive-piece.png";
import bgCongGive from "../../../../../assets/images/Mini-Game/bg-give-piece.png";
import bgCongGiveEn from "../../../../../assets/images/Mini-Game/bg-give-piece-en.png";

import bgRequestPieces from "../../../../../assets/images/Mini-Game/bg-request-pieces.png";
import bgNoMoreTurn from "../../../../../assets/images/Mini-Game/bg-no-more-turn.png";
import iconNoMoreTurn from "../../../../../assets/images/Mini-Game/icon-no-more-turn.png";
import bgReferral from "../../../../../assets/images/Mini-Game/bg-referral.png";
import bgReferralEn from "../../../../../assets/images/Mini-Game/bg-referral-en.png";
import bgReferralSuccessful from "../../../../../assets/images/Mini-Game/bg-referral-successful.png";
import bgReferralSuccessfulEn from "../../../../../assets/images/Mini-Game/bg-referral-successful-en.png";
import iconYe from "../../../../../assets/images/Mini-Game/icon-ye.png";
import { curStateMiniGame } from "../../../../../Redux/selector";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import { setData } from "../../../../../utils/localstorage";
import { setCookieExpireEndOfDay } from "../../../../../utils/cookie";
import { useTranslation } from "react-i18next";
import { postDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";

export default function PopupCongGivePiece({
  isOpen = true,
  className,
  type,
  data = null,
  handleClose = () => { },
}) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const dataMiniGame = useSelector(curStateMiniGame);
  const navigate = useNavigate();

  const onCancel = () => {
    handleClose();
    if (type === TYPE_GIVE_PIECE_SUCCESS.receivePiece || type === TYPE_GIVE_PIECE_SUCCESS.requestPiece) {
      postDataApi(API_PATH.miniGameDeleteReceiveGive, {
        type: type === TYPE_GIVE_PIECE_SUCCESS.receivePiece ? 1 : 2
      })
    }

    else if (type === TYPE_GIVE_PIECE_SUCCESS.referral_successful) {
      // setCookieExpireEndOfDay("invite_popup", 1);
      postDataApi(API_PATH.miniGameDeleteReceiveGive, {
        type: 3
      })
      dispatch(getDataSpinUserMiniGame()); // Set the flag to indicate the popup has been shown
    }

    dispatch(
      setOpenPopupGivePieceSuccess({
        isShow: false,
        type: null,
        data: null,
      })
    );

  };

  const handleClickPieceCollection = (award_id = null) => {
    navigate(
      (data?.dataDetail?.data?.award_id || award_id) ? `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}/${data?.dataDetail?.data?.award_id || award_id}` : `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}`
    );
    onCancel();
  };

  if (!type) {
    return <></>;
  }
  const bg_lang_bgCongGive = i18n.language === 'en' ? bgCongGiveEn : bgCongGive
  const bg_lang_bgReferral = i18n.language === 'en' ? bgReferralEn : bgReferral
  const bg_lang_bgReferralSuccessful = i18n.language === 'en' ? bgReferralSuccessfulEn : bgReferralSuccessful

  return (
    <BasePopup
      BasePopup
      open={isOpen}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      {type === TYPE_GIVE_PIECE_SUCCESS.receive ? (
        <Container>
          <div className="puzzle-piece-minigame position-relative">
            <img src={bgCongReceive} alt='' className='bg-con-mini' />
            <img
              src={iconClosePopup}
              alt=''
              className='rule-mini-close button-hover__minigame'
              onClick={onCancel}
            />
            <div className='main-content-mini-piece'>
              <div className='icon'>
                <img src={data?.dataDetail?.data?.image} alt='img-piece' />
              </div>
              <div className='header'>
                {t("mini_game.pop_up_receive.user_given").replace(
                  "X",
                  data?.dataDetail?.data?.owner_isdn
                )}
              </div>
              <div className='name name-piece__item'>
                {data?.dataDetail?.data?.piece_total_number} Prize{" "}
                {data?.dataDetail?.data?.award_name} - Piece (
                {data?.dataDetail?.data?.piece_name})
              </div>
              <div className='header'>
                {t("mini_game.pop_up_receive.promote")}
              </div>

              <div className='container-btn' onClick={() => handleClickPieceCollection()}>
                <ButtonAction srcBg={bgBtn} content='အပိုင်းအစများ စုစည်းမှု' />
              </div>
              <div className='footer-popup-mini-cong'>

                {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
                  "X",
                  dataMiniGame.configMiniGame?.minigame?.max_give_piece
                )} ${t("mini_game.pop_up_give_piece.turns_left")
                  .replace(
                    "X",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft
                  )
                  .replace(
                    "pieces",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1
                      ? "pieces"
                      : "piece"
                  )}`}
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.give ? (
        <Container>
          <div className='popup-coins'>
            <div
              className='container-bg'
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={bg_lang_bgCongGive} alt='' className='bg-con-mini' />
            </div>

            <img
              src={iconClosePopup}
              alt=''
              className='rule-mini-close button-hover__minigame'
              onClick={onCancel}
            />
            <div className='main-content-mini-piece'>
              <div className='icon'>
                <img src={data?.dataDetail?.data?.image} alt='img-piece' />
              </div>
              <div className='header'>
                {t("mini_game.you_have_successfully_given").replace("xxx", data?.dataDetail?.data?.owner_isdn).replace("piece_replace", data?.dataDetail?.data?.piece_name).replace().replace("prize_replace", data?.dataDetail?.data?.award_name)}"
                {/* 1 Prize{" "}{data?.dataDetail?.data?.award_name} - Piece (
                {data?.dataDetail?.data?.piece_name}) to user{" "}
                {data?.dataDetail?.data?.owner_isdn}. Check your piece
                collection now: */}
              </div>

              <div
                className='container-btn'
                onClick={() => handleClickPieceCollection()}
              >
                <ButtonAction srcBg={bgBtn} content='အပိုင်းအစများ စုစည်းမှု' />
              </div>
              <div className='footer-popup-mini-cong'>
                {t("mini_game.You_can_only_Give_and_Receive_up_to")}{" "}
                {dataMiniGame.configMiniGame?.minigame?.max_give_piece} {t("mini_game.pieces_each_cycle")} {t("mini_game.you_have")}{" "}
                {dataMiniGame.configMiniGame?.giveReceiveTurnLeft}
                {"     "}
                {dataMiniGame.configMiniGame?.minigame?.max_give_piece == dataMiniGame.configMiniGame?.giveReceiveTurnLeft ? "ခုရှိသည်။" : "ခု ကျန်သေးသည်။"}
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.receivePiece ? (
        <Container>
          <div className='popup-coins popup-success-piece'>
            <div className="puzzle-piece-minigame position-relative">
              <img src={bgRequestPieces} alt='' className='bg-con-mini' />
              <img
                src={iconClosePopup}
                alt=''
                className='rule-mini-close button-hover__minigame'
                onClick={onCancel}
              />
              <div className='main-content-mini-piece'>
                <div className='icon'>
                  <img src={data?.dataDetail?.data?.image || data?.image} alt='img-piece' />
                </div>
                <div className='header'>
                  {data?.message || ""}
                </div>

                <div
                  className='container-btn'
                  onClick={() => handleClickPieceCollection(data?.award_id)}
                >
                  <ButtonAction srcBg={bgBtn} content='အပိုင်းအစများ စုစည်းမှု' />
                </div>
                <div className='footer-popup-mini-cong'>
                  {t("mini_game.You_can_only_Give_and_Receive_up_to")}{" "}
                  {dataMiniGame.configMiniGame?.minigame?.max_give_piece} {t("mini_game.pieces_each_cycle")} {t("mini_game.you_have")}{" "}
                  {dataMiniGame.configMiniGame?.giveReceiveTurnLeft}
                  {"     "}
                  {dataMiniGame.configMiniGame?.minigame?.max_give_piece == dataMiniGame.configMiniGame?.giveReceiveTurnLeft ? "ခုရှိသည်။" : "ခု ကျန်သေးသည်။"}
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.requestPiece ? (
        <Container>
          <div className='popup-coins popup-success-piece'>
            <div className="puzzle-piece-minigame position-relative">
              <img src={bgRequestPieces} alt='' className='bg-con-mini' />
              <img
                src={iconClosePopup}
                alt=''
                className='rule-mini-close button-hover__minigame'
                onClick={onCancel}
              />
              <div className='main-content-mini-piece'>
                <div className='icon'>
                  <img src={data?.dataDetail?.data?.image || data?.image} alt='img-piece' />
                </div>
                <div className='header'>
                  {data?.message || ""}
                </div>

                <div
                  className='container-btn'
                  onClick={() => handleClickPieceCollection(data?.award_id)}
                >
                  <ButtonAction srcBg={bgBtn} content='အပိုင်းအစများ စုစည်းမှု' />
                </div>
                <div className='footer-popup-mini-cong'>
                  {t("mini_game.You_can_only_Give_and_Receive_up_to")}{" "}
                  {dataMiniGame.configMiniGame?.minigame?.max_give_piece} {t("mini_game.pieces_each_cycle")} {t("mini_game.you_have")}{" "}
                  {dataMiniGame.configMiniGame?.giveReceiveTurnLeft}
                  {"     "}
                  {dataMiniGame.configMiniGame?.minigame?.max_give_piece == dataMiniGame.configMiniGame?.giveReceiveTurnLeft ? "ခုရှိသည်။" : "ခု ကျန်သေးသည်။"}
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.user_run_out ? (
        <Container>
          <div className='popup-good-luck'>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={bgGoodluck} alt='' className='bg-con-mini' />
            </div>

            <img
              src={iconClosePopup}
              alt=''
              className='rule-mini-close button-hover__minigame'
              onClick={onCancel}
            />
            <div className='main-content-mini-piece'>
              <div className='icon'>
                <img src={iconPieceB} alt='' />
              </div>
              <div className='header'>
                {t("mini_game.pop_up_user_run_out.user_run_out")}
              </div>
              <div className='header'>{t("mini_game.pop_up_user_run_out.promote")}</div>

              <div className='container-btn'>
                <ButtonAction srcBg={bgBtn} content='Request' />
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.no_more_turns ? (
        <Container>
          <div className='popup-good-luck popup-no-coins'>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={bgNoMoreTurn} alt='' className='bg-con-mini' />
            </div>

            <img
              src={iconClosePopup}
              alt=''
              className='rule-mini-close button-hover__minigame'
              onClick={onCancel}
            />
            <div className='main-content-mini-piece'>
              <div className='icon'>
                <img src={iconNoMoreTurn} alt='' />
              </div>
              <div className='header'>
                {t("mini_game.popup_no_turns_give.you_have_no_more_turns_to_give_and_receive_puzzles_this_cycle")}
              </div>
              <div className='header'>
                {t("mini_game.popup_no_turns_give.keep_spinning_the_reels")}
              </div>

              <div className='footer-popup-mini-cong'>
                {t("mini_game.You_can_only_Give_and_Receive_up_to")}
                {dataMiniGame.configMiniGame?.minigame?.max_give_piece} {t("mini_game.pieces_each_cycle")}. {t("mini_game.you_have")}{" "}
                {dataMiniGame.configMiniGame?.giveReceiveTurnLeft}
                {"     "}
                {dataMiniGame.configMiniGame?.minigame?.max_give_piece == dataMiniGame.configMiniGame?.giveReceiveTurnLeft ? "ခုရှိသည်။" : "ခု ကျန်သေးသည်။"}
              </div>
            </div>
          </div>
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.referral_linked ? (
        <Container>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={bg_lang_bgReferral} alt='' className='bg-con-mini' />
          </div>

          <img
            src={iconClosePopup}
            alt=''
            className='rule-mini-close button-hover__minigame button-hover__minigame__referral'
            onClick={onCancel}
          />
          <div className='main-content-mini-piece main-content-mini-piece__referral'>
            <div className='header'>
              {t("mini_game.pop_up_invite_friend.ref_link").replace(
                "X",
                data ? data?.data?.referral_isdn : ""
              )}
            </div>
            <div className='header pt-3'>
              {t("mini_game.pop_up_invite_friend.ref_link_note")}
            </div>
          </div>
          <img src={iconYe} alt='' className='icon-footer-referral' />
        </Container>
      ) : type === TYPE_GIVE_PIECE_SUCCESS.referral_successful ? (
        <Container>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={bg_lang_bgReferralSuccessful} alt='' className='bg-con-mini' />
          </div>

          <img
            src={iconClosePopup}
            alt=''
            className='rule-mini-close button-hover__minigame button-hover__minigame__referral'
            onClick={onCancel}
          />
          <div className='main-content-mini-piece main-content-mini-piece__referral'>
            <div className='header'>
              {/* Your friend, {data?.user_referred || data?.data?.referral_isdn || ""}, has successfully confirmed
              your invitation! You received {data?.superCoinAdd ? `${data?.superCoinAdd} SUPER` : ""} {data?.data?.superCoinAdd ? `${data?.data?.superCoinAdd} super` : `${data?.normalCoinAdd || data?.data?.normalCoinAdd || ""}`} coin! */}
              {
                data?.data?.message || data?.message || ""
              }
              {/* {`${t("mini_game.pop_up_invite_friend.referral_success").replace(
                "X",
                data?.user_referred || data?.data?.referral_isdn || ""
              )} ${t("mini_game.pop_up_invite_friend.ref_success_trailing")}`} */}
            </div>
            <div className='header pt-3'>
              {t("mini_game.pop_up_invite_friend.ref_promote")}
            </div>
          </div>
          <img src={iconYe} alt='' className='icon-footer-referral' />
        </Container>
      ) : null}
    </BasePopup>
  );
}

const Container = styled.div`
  position: relative;

  .icon-footer-referral {
    position: absolute;
    bottom: 14px;
    left: 50%;
    max-width: 80%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .popup-coins {
    .container-bg {
      .bg-con-mini {
        height: 605px;
      }
    }
  }

  .popup-good-luck {
    .main-content-mini-piece {
      top: 220px;

      @media (max-width: 768px) {
        top: 160px;
      }
    }

    .header {
      color: #1d2939;
    }

    .rule-mini-close {
      top: 50px;
      right: 20px;
    }

    .footer-popup-mini-cong {
      color: #475467;
    }

    .icon {
      margin: 0 0 10px;

      @media (max-width: 768px) {
        margin: 0 0 5px;
      }
    }
  }

  .popup-no-coins {
    .rule-mini-close {
      right: -2%;
      top: 20px;
    }

    .main-content-mini-piece {
      width: calc(100% - 60px);
      top: 195px;
    }

    .header {
      max-width: 401px;
      margin: 0 auto;

      & + .footer-popup-mini-cong {
        margin-top: 24px;
      }
    }

    .btn-cancel-change {
      margin-top: 10px;
    }

    .btn-confirm-change {
      margin-top: 15px;
    }

    .mini-icon-change {
      padding: 12px 0;
    }

    .coins-now-content {
      font-size: 24px;
      font-weight: 600;
      color: #101828;
      text-align: center;
    }

    .container-popup-mini-rule {
      margin-top: 10px;
      padding: 0 12px;
    }

    .container-icon-mission {
      width: 50px;
      height: 50px;

      img {
        width: 27px;
      }
    }

    .mission-name {
      font-size: 16px;
    }

    .mini-mission-footer {
      font-size: 14px;
    }

    .item-mission-container-mini {
      padding: 10px;
    }

    .flex-mission-icon {
      gap: 10px;
    }

    .change-turn {
      margin-left: -64px;
    }

    .warning-change-turn {
      font-size: 12px;
    }
  }

  .bg-con-mini {
    height: 668px;
  }

  .rule-mini-close {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 4;
  }

  .button-hover__minigame__referral {
    top: -20px;
    right: -35px;
  }

  .container-btn {
    margin: 10px 0;
    margin-bottom: 10px;
  }

  .footer-popup-mini-cong {
    text-align: center;
    font-style: italic;
    font-size: 14px;

    @media (max-width: 385px) {
      font-size: 12px;
    }
  }

  .name {
    font-size: 36px;
    text-align: center;
    font-family: "Ganache", sans-serif;
    color: #954911;

    @media (max-width: 375px) {
      font-size: 28px;
    }
  }

  .icon {
    text-align: center;
    margin: 25px 0;
    margin-bottom: 16px;

    img {
      max-height: 185px;
      max-width: 100%;
    }
  }

  .main-content-mini-piece {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 125px;
    z-index: 2;
    font-size: 16px;
    color: #64310b;
    font-weight: 500;
  }

  .main-content-mini-piece__referral {
    top: 156px;
    width: calc(100% - 20%);
    z-index: 2;
    .header {
      font-size: 20px;
    }

    .pt-3 {
      padding-top: 15px;
    }
  }

  .name-piece__item{
    font-size: 28px;
    line-height: 30px;
    padding: 6px 0;
  }

  .bg-super-con-mini {
    height: 772px;
  }

  .header {
    font-weight: 500;
    text-align: center;

    @media (max-width: 375px) {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .popup-coins {
      .container-bg {
        .bg-con-mini {
          height: 500px;
        }
      }
      .main-content-mini-piece {
        top: 135px;
      }
    }

    .popup-free-bid {
      .main-content-mini-piece {
        top: 110px;
      }

      .footer-popup-mini-cong,
      .header {
        padding: 0;
        font-size: 14px;
      }
    }

    .popup-no-coins {
      margin: 0 -25px;

      .main-content-mini-piece {
        width: calc(100% - 20px);
      }

      .btn-container button {
        width: 30px;
        height: 30px;
      }

      /* .btn-total {
        height: 30px;
      } */

      .btn-change-turn {
        font-size: 14px;
      }

      .container-change-coins-mini .btn-change-turn {
        width: max-content;
      }

      .mini-change-coins-header {
        font-size: 13px;
      }

      .total-mini-change {
        font-size: 18px;
      }

      .bg-con-mini {
        height: 668px;
      }

      .header {
        font-size: 16px;
      }

      .coins-now-content {
        font-size: 14px;
      }

      .mission-name {
        font-size: 14px;
        line-height: 21px;
      }

      .mini-mission-footer {
        font-size: 12px;
      }

      .container-popup-mini-rule {
        padding: 0;
      }
    }

    .main-content-mini-piece {
      top: 100px;
      width: calc(100% - 55px);
    }

    .main-content-mini-piece__referral {
      top: 120px;
    }

    .bg-con-mini {
      height: 525px;
    }

    .main-content-mini-piece {
      max-width: 362px;
    }

    .bg-super-con-mini {
      height: 640px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      text-align: center;
    }

    .icon {
      margin: 0px 0;
      margin-bottom: 5px;

      img {
        max-height: 150px;
      }
    }

    .button-action-popup-mini {
      min-height: 45px;
      width: 100% !important;
      text-align: center;

      img {
        height: 45px;
        width: 260px;
      }
    }

    .footer-popup-mini-cong,
    .header {
      padding: 0 10px;
    }

    .main-content-mini-piece__referral {
      .header {
        font-size: 16px;
      }
    }

    .icon-footer-referral {
      max-height: 240px;
      bottom: 11px;
    }

    .button-hover__minigame__referral {
      top: 10px;
      right: 0;
    }
  }

  @media (max-width: 576px) {
    .popup-success-piece{
      .header, .footer-popup-mini-cong{
        font-size: 13px;
      }

       .icon img {
        /* max-height: 120px; */
    }
    }
  }

    @media (max-width: 400px) {
       .icon img {
        max-height: 120px;
      }
  }

    .puzzle-piece-minigame{

    .main-content-mini-piece{
      position: relative;
      top: 65px !important;
      /* max-width: calc(100% - 60px); */
      max-width: 100%;
      padding: 0 30px;
      width: auto;
      left: 50%;
      transform: translateX(-50%)
    }

    .bg-super-con-mini, .bg-con-mini{
      position: absolute;
      height: calc(100% + 160px);
      min-height: auto;
      max-height: calc(100% + 160px);
      width: calc(100%);
      top: -65px;
      left: 50%;
      transform: translateX(-50%)
    }

    .button-action-popup-mini{
      text-align: center;
      width: 100%;
    }

    .main-super-puzzle{
      width: auto !important;
    }

    .rule-mini-close{
      top: -46px;
    }
  }
`;
